import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { BookOpen, ArrowRight } from "lucide-react";

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    http.get("/blog/posts").then(({ data }) => {
      setPosts((data.posts || []).slice(0, 3));
    }).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  const resolveCover = (url) => (url ? (url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`) : null);

  return (
    <section data-testid="blog-preview" className="py-20 bg-app-alt border-t border-[var(--card-border)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 gap-4">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">The notebook</span>
            <h2 className="font-serif text-3xl sm:text-4xl mt-3 leading-tight text-app">
              Guides, FAQs & <em className="text-[#C9A961]">policy breakdowns</em>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-preview-all"
            className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-[#C9A961] hover:text-[#D7B974] self-start sm:self-auto"
          >
            All articles <ArrowRight className="w-3 h-3" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-preview-${p.slug}`}
              className="group rounded-2xl border border-[var(--card-border)] bg-app overflow-hidden hover:border-[#C9A961] transition-colors"
            >
              {p.cover_url ? (
                <div className="aspect-[16/9] bg-slate-900/40 overflow-hidden">
                  <img
                    src={resolveCover(p.cover_url)}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              ) : (
                <div className="aspect-[16/9] bg-gradient-to-br from-[#0B1E3F] to-[#162A4D] flex items-center justify-center">
                  <BookOpen className="w-8 h-8 text-[#C9A961]/40" />
                </div>
              )}
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-widest text-[#C9A961] font-semibold mb-1.5">{p.category}</div>
                <h3 className="font-serif text-lg leading-snug group-hover:text-[#C9A961] transition-colors line-clamp-2">
                  {p.title}
                </h3>
                <p className="text-xs text-app-muted mt-2 line-clamp-2">
                  {p.excerpt || p.body.slice(0, 140)}
                </p>
                <div className="mt-3 text-[11px] uppercase tracking-widest text-app-muted">
                  {new Date(p.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
